import { defaultLang, supportedLangs } from '@geartracker/types';

import translationDe from './langs/de.json';
import translationEn from './langs/en.json';
import translationEs from './langs/es.json';
import translationFr from './langs/fr.json';
import translationIt from './langs/it.json';

import * as Sentry from '@sentry/react';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// ----------------------------------------------------------------------

const returnTwoFirstCharacters = (lng: string) => {
  if (lng.length < 2) {
    return lng;
  }
  return lng.substring(0, 2);
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(
    {
      detection: {
        order: ['querystring', 'localStorage', 'navigator'],
        caches: ['localStorage'],
        convertDetectedLanguage: (lng) => {
          return returnTwoFirstCharacters(lng);
        },
      },
      resources: {
        en: { translations: translationEn },
        fr: { translations: translationFr },
        es: { translations: translationEs },
        it: { translations: translationIt },
        de: { translations: translationDe },
      },
      fallbackLng: defaultLang,
      supportedLngs: supportedLangs,
      nonExplicitSupportedLngs: true,
      debug: false,
      ns: ['translations'],
      defaultNS: 'translations',
      saveMissing: true,
      missingKeyHandler: (lngs, _ns, key) => {
        const message = `Missing translation: ${key}`;
        console.warn(message);
        Sentry.captureMessage('Missing translation', {
          extra: {
            key,
            lngs,
          },
          level: 'warning',
          tags: {
            feature: 'translations',
          },
        });
      },
      interpolation: {
        escapeValue: false,
        skipOnVariables: false,
      },
    },
    () => {
      document.documentElement.lang =
        i18n.resolvedLanguage || i18n.language || defaultLang;
    },
  );

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
